import { create } from 'zustand';

const THEME_STORAGE_KEY = 'admin-theme';
const resolveInitialTheme = (): 'light' | 'dark' => {
  if (typeof window === 'undefined') return 'dark';
  const raw = window.localStorage.getItem(THEME_STORAGE_KEY);
  return raw === 'light' ? 'light' : 'dark';
};

const applyTheme = (theme: 'light' | 'dark') => {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('data-theme', theme);
};

interface UIState {
  sidebarCollapsed: boolean;
  theme: 'light' | 'dark';
  loading: boolean;
  modalOpen: boolean;
  inboxUnreadCount: number;
  toggleSidebar: () => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
  setTheme: (theme: 'light' | 'dark') => void;
  setLoading: (loading: boolean) => void;
  openModal: () => void;
  closeModal: () => void;
  setInboxUnreadCount: (count: number) => void;
}

const initialTheme = resolveInitialTheme();
applyTheme(initialTheme);

export const useUIStore = create<UIState>((set) => ({
  sidebarCollapsed: false,
  theme: initialTheme,
  loading: false,
  modalOpen: false,
  inboxUnreadCount: 0,
  toggleSidebar: () =>
    set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
  setTheme: (theme) => {
    set({ theme });
    applyTheme(theme);
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    }
  },
  setLoading: (loading) => set({ loading }),
  openModal: () => set({ modalOpen: true }),
  closeModal: () => set({ modalOpen: false }),
  setInboxUnreadCount: (count) => set({ inboxUnreadCount: count }),
}));
